import { disconnectSocket } from './typeMessages'

const select = (state, location) => {
  return state.locations[location].lastUpdate
}

export function isConnect (store, location) {
  let oldUpdate = null
  let timeout = null
  return () => {
    let lastUpdate = select(store.getState(), location)
    if (lastUpdate === oldUpdate) return
    oldUpdate = lastUpdate
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      store.dispatch(disconnectSocket({ location }))
    }, 30000)
  }
}



// WEBPACK FOOTER //
// ./src/store/listeners.js